// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

// styles
const LoaderWrapper = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1301,
    width: '100%'
});

// ==============================|| LOADER ||============================== //
const Loader = () => (
    <LoaderWrapper>
        <LinearProgress color="primary" />
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItem: 'center' }}>
            <CircularProgress />
        </Box> */}
    </LoaderWrapper>
);

export default Loader;
